export default __webpack_public_path__ + "static/branding2-6d3f3f3be8abe5bac6080de34dc53012.webp";